import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const submitEditStationData = createAsyncThunk(
  "submitEditStation/fetchEditSubmitStation",
  async ({ stationId, payload }) => {
    try {
      const response = await api.post(
        `prometheus/station/${stationId}/edit/`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error Submitting Data:", error);
      return error.response.data;
    }
  }
);

const SubmitEditStationSlice = createSlice({
  name: "submitEditStation",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitEditStationData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitEditStationData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(submitEditStationData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  },
});

export default SubmitEditStationSlice.reducer;
